// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Styles from "./styles";
import * as Caml_obj from "bs-platform/lib/es6/caml_obj.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as MaterialUi_Button from "@jsiebern/bs-material-ui/src/MaterialUi_Button.bs.js";
import * as MaterialUi_Typography from "@jsiebern/bs-material-ui/src/MaterialUi_Typography.bs.js";
import * as Styles$1 from "@material-ui/core/styles";

var make = Styles.ModeTab;

var ModeTab = {
  make: make
};

function adjustLightness(item) {
  return {
          backgroundColor: item,
          color: "inherit",
          fontWeight: "bold"
        };
}

function markClicked(theme, mode, primaryMode) {
  var dark = theme.palette.primary.dark;
  var light = theme.palette.primary.light;
  return adjustLightness(Caml_obj.caml_equal(mode, primaryMode) ? dark : light);
}

function Modes(Props) {
  var mode = Props.mode;
  var setMode = Props.setMode;
  var modes = [
    "Work",
    "ShortBreak",
    "LongBreak"
  ];
  var theme = Styles$1.useTheme();
  var match = $$Array.map((function (item, param) {
          return Curry._1(setMode, (function (param) {
                        return item;
                      }));
        }), modes);
  if (match.length !== 3) {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "modes.res",
            34,
            6
          ],
          Error: new Error()
        };
  }
  var setWork = match[0];
  var setShort = match[1];
  var setLong = match[2];
  var match$1 = $$Array.map((function (item) {
          return markClicked(theme, mode, item);
        }), modes);
  if (match$1.length !== 3) {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "modes.res",
            36,
            6
          ],
          Error: new Error()
        };
  }
  var markWork = match$1[0];
  var markShort = match$1[1];
  var markLong = match$1[2];
  return React.createElement(make, {
              children: null
            }, React.createElement(Core.Button, MaterialUi_Button.makeProps(undefined, undefined, undefined, undefined, setWork, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(React.createElement(Core.Typography, MaterialUi_Typography.makeProps(undefined, "For Work", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Contained", undefined, undefined, undefined, Caml_option.some(markWork), undefined)), React.createElement(Core.Button, MaterialUi_Button.makeProps(undefined, undefined, undefined, undefined, setShort, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(React.createElement(Core.Typography, MaterialUi_Typography.makeProps(undefined, "For Short breaks", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Contained", undefined, undefined, undefined, Caml_option.some(markShort), undefined)), React.createElement(Core.Button, MaterialUi_Button.makeProps(undefined, undefined, undefined, undefined, setLong, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(React.createElement(Core.Typography, MaterialUi_Typography.makeProps(undefined, "For Long Breaks", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Contained", undefined, undefined, undefined, Caml_option.some(markLong), undefined)));
}

var Style;

var make$1 = Modes;

var $$default = Modes;

export {
  ModeTab ,
  Style ,
  adjustLightness ,
  markClicked ,
  make$1 as make,
  $$default ,
  $$default as default,
  
}
/* make Not a pure module */
